import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assignedOrder: false,
};

const assignOrderSlice = createSlice({
  name: "assignOrder",
  initialState,
  reducers: {
    isOrderAssigned: (state) => {
      state.assignedOrder = !state.assignedOrder;
    },
  },
});

export const { isOrderAssigned } = assignOrderSlice.actions;

export default assignOrderSlice.reducer;
